import React, { useCallback } from 'react';

import { DownloadButton } from '../../../../../components/download-button';
import Utils from '../../../../../utils/immersive_utils';

type DownloadButtonProps = {
  IsToDisplay: boolean;
  data: any[];
  header: string[];
  account: { exchange: string; name: string };
  pnlRiskToken: string;
};

export const PnlDownloadButton: React.FC<DownloadButtonProps> = ({
  IsToDisplay,
  data,
  header,
  account,
  pnlRiskToken,
}) => {
  const handleOnDownloadPnl = useCallback(() => {
    const csvData: Array<Array<string | number>> = [];

    const flatten = (nodes: any[]) => {
      nodes.forEach((node) => {
        if (node.values && node.values.length) {
          const row = [
            node.label,
            ...node.values.map((cell: any) => {
              if (cell == null) return '';
              if (typeof cell === 'object') {
                if (cell.props?.children !== undefined) {
                  return cell.props.children;
                }
                if ('value' in cell) {
                  return cell.value;
                }
                if ('y' in cell) {
                  return cell.y;
                }
                return '';
              }
              return cell;
            }),
          ];
          csvData.push(row);
        }
        if (node.children) {
          flatten(node.children);
        }
      });
    };

    flatten(data);

    const { exchange, name } = account;

    const date = new Date().toISOString();
    const filename = `PNL-${exchange}-${name}-${pnlRiskToken}-${date}.csv`;
    const csvHeaders: string[] = ['Label', ...header];

    Utils.downloadToCsv(filename, csvData, csvHeaders);
  }, [data, header]);
  if (!IsToDisplay) return null;

  return <DownloadButton onClick={handleOnDownloadPnl} />;
};
